(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kl-studio-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kl-studio-home')) {
  customElements.define('kl-studio-home', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cleanups = [];
      this.timers = new Set();
      this.frame = 0;
      const initialize = () => {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.initialize();
      };
      if (document.readyState === 'loading') {
        this.listen(document, 'DOMContentLoaded', initialize, { once: true });
      } else {
        queueMicrotask(initialize);
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.cleanups?.forEach(cleanup => cleanup());
      this.timers?.forEach(timer => clearTimeout(timer));
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      this.controller = null;
      this.initialized = false;
      this.pendingJump = null;
    }

    listen(target, type, listener, options = {}) {
      target.addEventListener(type, listener, { ...options, signal: this.controller.signal });
    }

    later(callback, delay) {
      const timer = setTimeout(() => {
        this.timers.delete(timer);
        callback();
      }, delay);
      this.timers.add(timer);
      return timer;
    }

    clearLater(timer) {
      clearTimeout(timer);
      this.timers.delete(timer);
    }

    initialize() {
      this.root = this.matches('.kl-studio') ? this : this.querySelector('.kl-studio') || this;
      this.nav = this.querySelector('[data-studio-nav]');
      this.links = Array.from(this.nav?.querySelectorAll('[data-jump]') || []);
      this.sections = Array.from(this.querySelectorAll('[data-collection-section]'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.rails = [];
      this.activeSection = null;
      this.stickyTop = -1;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.isConnected) return;
          this.measureHeader();
          this.updateActiveSection();
          this.rails.forEach(rail => rail.update());
        });
      };
      this.resizeObserver = new ResizeObserver(this.schedule);
      if (this.nav) this.resizeObserver.observe(this.nav);
      this.sections.forEach(section => this.resizeObserver.observe(section));
      this.querySelectorAll('[data-rail]').forEach(rail => this.initializeRail(rail));
      this.querySelectorAll('.kl-studio-card').forEach(card => this.initializeCard(card));
      this.initializeMotion();
      this.observeHeaders();
      this.listen(window, 'scroll', () => {
        this.schedule();
        if (this.pendingJump) this.queueJumpCorrection();
      }, { passive: true });
      this.listen(window, 'resize', this.schedule, { passive: true });
      this.listen(window, 'scrollend', () => this.correctJump(), { passive: true });
      this.listen(document, 'shopify:section:load', () => {
        this.observeHeaders();
        this.schedule();
      });
      this.listen(document, 'shopify:section:reorder', this.schedule);
      this.listen(this, 'click', event => this.handleJump(event));
      this.listen(window, 'wheel', () => { this.pendingJump = null; }, { passive: true });
      this.listen(window, 'touchstart', () => { this.pendingJump = null; }, { passive: true });
      this.listen(window, 'pointerdown', () => { this.pendingJump = null; }, { passive: true });
      this.listen(window, 'keydown', event => {
        if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', 'Escape', ' '].includes(event.key)) {
          this.pendingJump = null;
        }
      });
      this.listen(this, 'load', this.schedule, { capture: true });
      this.schedule();
    }

    behavior() {
      return this.reducedMotion.matches || this.root.dataset.paused === 'true' ? 'instant' : 'smooth';
    }

    observeHeaders() {
      this.headerObserver?.disconnect();
      this.headerNodes?.forEach(node => this.resizeObserver.unobserve(node));
      this.headerNodes = Array.from(document.querySelectorAll('#HeaderWrapper, #HeaderWrapper .site-header, .announcement-bar'));
      this.headerObserver = new MutationObserver(this.schedule);
      const observed = new Set();
      this.headerNodes.forEach(node => {
        this.resizeObserver.observe(node);
        let ancestor = node;
        for (let depth = 0; ancestor && ancestor !== document.body && depth < 4; depth += 1) {
          if (!observed.has(ancestor)) {
            observed.add(ancestor);
            this.headerObserver.observe(ancestor, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
          }
          ancestor = ancestor.parentElement;
        }
      });
    }

    measureHeader() {
      const rectangles = [];
      this.headerNodes.forEach(node => {
        const rect = node.getBoundingClientRect();
        const style = getComputedStyle(node);
        if (rect.height <= 0 || rect.bottom <= 0 || style.display === 'none' || style.visibility === 'hidden') return;
        let persistent = false;
        let ancestor = node;
        for (let depth = 0; ancestor && ancestor !== document.body && depth < 4; depth += 1) {
          const ancestorStyle = getComputedStyle(ancestor);
          const ancestorRect = ancestor.getBoundingClientRect();
          if (ancestorStyle.position === 'fixed') persistent = true;
          if (ancestorStyle.position === 'sticky' && ancestorRect.top <= (parseFloat(ancestorStyle.top) || 0) + 2) persistent = true;
          ancestor = ancestor.parentElement;
        }
        if (persistent || (rect.top <= 2 && rect.bottom > 0)) rectangles.push({ rect, persistent });
      });
      rectangles.sort((a, b) => a.rect.top - b.rect.top);
      let edge = 0;
      rectangles.forEach(({ rect, persistent }) => {
        if (rect.top <= edge + 2 || (persistent && rect.top < window.innerHeight / 2)) edge = Math.max(edge, rect.bottom);
      });
      const top = Math.max(0, Math.round(edge));
      if (top !== this.stickyTop) {
        this.stickyTop = top;
        this.root.style.setProperty('--kl-studio-sticky-top', `${top}px`);
      }
      return top;
    }

    targetFor(link) {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#') || href.length < 2) return null;
      try {
        const target = document.getElementById(decodeURIComponent(href.slice(1)));
        return target && this.contains(target) ? target : null;
      } catch {
        return null;
      }
    }

    handleJump(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('[data-jump]');
      if (!link || !this.contains(link)) return;
      const target = this.targetFor(link);
      if (!target) return;
      event.preventDefault();
      this.pendingJump = { target, keyboard: event.detail === 0, corrections: 0 };
      const url = new URL(window.location.href);
      url.hash = target.id;
      if (window.location.hash !== url.hash) history.pushState(null, '', url);
      window.scrollTo({ top: this.jumpPosition(target), behavior: this.behavior() });
      this.queueJumpCorrection();
      this.schedule();
    }

    jumpPosition(target) {
      const offset = this.measureHeader() + (this.nav?.getBoundingClientRect().height || 0) + 8;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      return Math.max(0, Math.min(maximum, top));
    }

    queueJumpCorrection() {
      this.clearLater(this.jumpTimer);
      this.jumpTimer = this.later(() => this.correctJump(), 180);
    }

    correctJump() {
      const pending = this.pendingJump;
      if (!pending || !pending.target.isConnected) return;
      this.clearLater(this.jumpTimer);
      const top = this.jumpPosition(pending.target);
      if (Math.abs(top - window.scrollY) > 2 && pending.corrections < 2) {
        pending.corrections += 1;
        window.scrollTo({ top, behavior: 'instant' });
        this.queueJumpCorrection();
        return;
      }
      this.pendingJump = null;
      if (pending.keyboard) {
        const target = pending.target;
        const original = target.getAttribute('tabindex');
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        const restore = () => {
          if (original === null) target.removeAttribute('tabindex');
          else target.setAttribute('tabindex', original);
        };
        this.listen(target, 'blur', restore, { once: true });
        this.cleanups.push(restore);
      }
      this.schedule();
    }

    updateActiveSection() {
      if (!this.nav || !this.sections.length) return;
      const edge = this.nav.getBoundingClientRect().bottom + 100;
      let active = this.sections[0];
      this.sections.forEach(section => {
        if (section.getBoundingClientRect().top <= edge) active = section;
      });
      const navWidth = this.nav.clientWidth;
      if (active === this.activeSection && navWidth === this.navWidth) return;
      this.activeSection = active;
      this.navWidth = navWidth;
      let activeLink;
      this.links.forEach(link => {
        if (this.targetFor(link) === active) {
          link.setAttribute('aria-current', 'location');
          activeLink = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });
      if (!activeLink) return;
      const navRect = this.nav.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();
      if (linkRect.left < navRect.left + 12 || linkRect.right > navRect.right - 12) {
        this.nav.scrollBy({ left: linkRect.left - navRect.left - (this.nav.clientWidth - linkRect.width) / 2, behavior: this.behavior() });
      }
    }

    initializeCard(card) {
      const button = card.querySelector('[data-image-toggle]');
      const image = card.querySelector('[data-card-image]');
      if (!button || !image) return;
      let hovered = false;
      let manual = card.classList.contains('is-second') ? true : null;
      const update = () => {
        const second = manual ?? hovered;
        card.classList.toggle('is-second', second);
        button.setAttribute('aria-pressed', String(second));
        const label = second ? button.dataset.firstLabel : button.dataset.secondLabel;
        if (label) button.setAttribute('aria-label', label);
      };
      this.listen(image, 'pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        hovered = true;
        update();
      });
      this.listen(image, 'pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        hovered = false;
        manual = null;
        update();
      });
      this.listen(button, 'click', event => {
        event.preventDefault();
        event.stopPropagation();
        manual = !(manual ?? hovered);
        update();
      });
      button.hidden = false;
      update();
    }

    initializeMotion() {
      const motionDisabled = this.root.dataset.paused === 'true';
      const update = () => {
        this.root.dataset.paused = String(motionDisabled || this.reducedMotion.matches);
      };
      this.listen(this.reducedMotion, 'change', update);
      update();
    }

    initializeRail(rail) {
      const track = rail.querySelector('[data-rail-track]');
      if (!track) return;
      const slides = Array.from(track.querySelectorAll('[data-slide]'));
      const previous = rail.querySelector('[data-prev]');
      const next = rail.querySelector('[data-next]');
      const controls = rail.querySelector('[data-rail-controls]');
      const range = rail.querySelector('[data-range]');
      const progress = rail.querySelector('[data-progress]');
      const originalTabIndex = track.getAttribute('tabindex');
      if (originalTabIndex === null) track.tabIndex = 0;
      const sign = () => getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const maximum = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const position = () => Math.max(0, Math.min(maximum(), track.scrollLeft * sign()));
      const move = amount => track.scrollTo({ left: Math.max(0, Math.min(maximum(), position() + amount)) * sign(), behavior: this.behavior() });
      const step = () => {
        const first = slides[0];
        if (!first) return track.clientWidth;
        const width = first.getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return Math.max(width + gap, track.clientWidth * 0.8);
      };
      const update = () => {
        const max = maximum();
        const current = position();
        if (controls) controls.hidden = max <= 2 || slides.length < 2;
        if (previous) {
          previous.hidden = false;
          previous.disabled = current <= 2;
          previous.setAttribute('aria-disabled', String(previous.disabled));
        }
        if (next) {
          next.hidden = false;
          next.disabled = current >= max - 2;
          next.setAttribute('aria-disabled', String(next.disabled));
        }
        if (range) {
          const viewport = track.getBoundingClientRect();
          const visible = slides.map((slide, index) => {
            const rect = slide.getBoundingClientRect();
            const overlap = Math.max(0, Math.min(rect.right, viewport.right) - Math.max(rect.left, viewport.left));
            return { index, overlap, visible: overlap >= Math.min(rect.width, track.clientWidth) * 0.5 && overlap > 0 };
          });
          let shown = visible.filter(slide => slide.visible);
          if (!shown.length && visible.length) shown = [visible.reduce((best, slide) => slide.overlap > best.overlap ? slide : best)];
          const first = shown.length ? shown[0].index + 1 : 0;
          const last = shown.length ? shown[shown.length - 1].index + 1 : 0;
          const template = first === last ? range.dataset.singleTemplate || '{first} of {total}' : range.dataset.rangeTemplate || '{first}–{last} of {total}';
          const text = template.replaceAll('{first}', String(first)).replaceAll('{last}', String(last)).replaceAll('{total}', String(slides.length));
          if (range.textContent !== text) range.textContent = text;
        }
        if (progress) {
          progress.style.transformOrigin = 'left';
          progress.style.transform = `scaleX(${max > 2 ? current / max : 1})`;
        }
      };
      if (previous) this.listen(previous, 'click', () => move(-step()));
      if (next) this.listen(next, 'click', () => move(step()));
      this.listen(track, 'scroll', this.schedule, { passive: true });
      this.listen(rail, 'keydown', event => {
        const target = event.target;
        if (target.closest('input, select, textarea, [contenteditable="true"]')) return;
        const control = target.closest('[data-rail-controls], [data-prev], [data-next]');
        if (target !== track && target !== rail && !control) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') move(-maximum());
        else if (event.key === 'End') move(maximum());
        else move(step() * (event.key === 'ArrowRight' ? 1 : -1) * sign());
      });
      let drag = null;
      let suppressUntil = 0;
      let originalSnap = '';
      let originalScrollBehavior = '';
      const finishDrag = event => {
        if (!drag || (event?.pointerId !== undefined && event.pointerId !== drag.id)) return;
        const completed = drag;
        drag = null;
        if (completed.moved) suppressUntil = performance.now() + 450;
        if (track.hasPointerCapture(completed.id)) track.releasePointerCapture(completed.id);
        track.style.scrollSnapType = originalSnap;
        track.style.scrollBehavior = originalScrollBehavior;
        track.classList.remove('is-dragging');
        this.schedule();
      };
      this.listen(track, 'pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || maximum() <= 2) return;
        if (event.target.closest('button, input, select, textarea, [contenteditable="true"]')) return;
        originalSnap = track.style.scrollSnapType;
        originalScrollBehavior = track.style.scrollBehavior;
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: track.scrollLeft, moved: false };
      });
      this.listen(window, 'pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 6) return;
        if (!drag.moved && Math.abs(event.clientY - drag.y) > Math.abs(distance)) {
          finishDrag(event);
          return;
        }
        if (!drag.moved) {
          drag.moved = true;
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          track.classList.add('is-dragging');
          track.setPointerCapture(drag.id);
        }
        event.preventDefault();
        track.scrollLeft = drag.scroll - distance;
      }, { passive: false });
      this.listen(window, 'pointerup', finishDrag, { passive: true });
      this.listen(window, 'pointercancel', finishDrag, { passive: true });
      this.listen(track, 'lostpointercapture', finishDrag, { passive: true });
      this.listen(track, 'dragstart', event => event.preventDefault());
      this.listen(track, 'click', event => {
        if (event.detail > 0 && performance.now() < suppressUntil) {
          suppressUntil = 0;
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true });
      this.resizeObserver.observe(track);
      slides.forEach(slide => this.resizeObserver.observe(slide));
      this.rails.push({ update });
      this.cleanups.push(() => {
        finishDrag();
        if (originalTabIndex === null) track.removeAttribute('tabindex');
      });
      update();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  const rootSelector = '.kl-studio-collection';
  const buttonSelector = '.kl-studio-layout-switch [data-studio-layout]';
  const storageKey = 'kl-studio-collection-layout';
  const instanceKey = '__klStudioCollectionLayout';
  const originalImageSizes = new WeakMap();

  if (window[instanceKey]) {
    window[instanceKey].refresh(document);
    return;
  }

  function isLayout(value) {
    return value === 'grid' || value === 'editorial';
  }

  let selectedLayout = 'grid';
  try {
    const savedLayout = window.localStorage.getItem(storageKey);
    if (isLayout(savedLayout)) selectedLayout = savedLayout;
  } catch (_) {}

  function render(root) {
    root.dataset.layout = selectedLayout;
    root.querySelectorAll(buttonSelector).forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.studioLayout === selectedLayout));
    });
    root.querySelectorAll('.kl-studio-catalog-card .grid-product__image-mask img').forEach(image => {
      if (!originalImageSizes.has(image)) originalImageSizes.set(image, image.getAttribute('sizes'));
      const sizes = selectedLayout === 'editorial' ? '(min-width: 769px) 60vw, 100vw' : originalImageSizes.get(image);
      if (sizes === null) image.removeAttribute('sizes');
      else if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
    });
  }

  function refresh(scope) {
    const roots = new Set();
    if (scope instanceof Element) {
      const containingRoot = scope.closest(rootSelector);
      if (containingRoot) roots.add(containingRoot);
    }
    scope.querySelectorAll(rootSelector).forEach(root => roots.add(root));
    roots.forEach(render);
  }

  window[instanceKey] = { refresh };

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(buttonSelector);
    if (!button || !button.closest(rootSelector) || !isLayout(button.dataset.studioLayout)) return;
    event.preventDefault();
    selectedLayout = button.dataset.studioLayout;
    try {
      window.localStorage.setItem(storageKey, selectedLayout);
    } catch (_) {}
    refresh(document);
  });

  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    selectedLayout = isLayout(event.newValue) ? event.newValue : 'grid';
    refresh(document);
  });

  document.addEventListener('shopify:section:load', event => {
    if (event.target instanceof Element) refresh(event.target);
  });

  function initialize() {
    refresh(document);
    new MutationObserver(records => {
      const roots = new Set();
      records.forEach(record => {
        record.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          const containingRoot = node.closest(rootSelector);
          if (containingRoot) roots.add(containingRoot);
          node.querySelectorAll(rootSelector).forEach(root => roots.add(root));
        });
      });
      roots.forEach(render);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
